import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, share } from 'rxjs/operators';
import { error } from '@angular/compiler/src/util';
import { ENTITY_API_URL } from './endpoints';

@Injectable()
export class BaseService {
    httpClient: HttpClient;
    constructor(http: HttpClient) {
        this.httpClient = http;
    }

    getHttpHeaders = () => {
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        return headers;
    }

    getItems(params: any): Observable<any> { // function to be override in client class
        return;
    }

    update(id: number, updateParams: any): Observable<any> { // function to be override in client class
        return ;
    }
    delete(id: number): Observable<any> { // function to be override in client class
        return ;
    }
    
    makeQueryString(postData): string {
        let queryString = '';
        for (const field of Object.keys(postData)) {
            if (postData[field] !== undefined && postData[field] !== null) {
                queryString = queryString + field + '=' + encodeURIComponent(postData[field]) + '&';
            }
        }
        return queryString;
    }

    getHttpOptions(): object {
        const options = {
            withCredentials: true,
            headers: this.getHttpHeaders()
        };
        return options;
    }

    getRequest = (url, option) => {
        return new Observable(observer => {

            this.httpClient.get(url)
                .subscribe(returnVal => {
                    observer.next({ apiCallStatus: 1, data: returnVal });
                    observer.complete();
                }, (err) => {                   
                    observer.next({ apiCallStatus: 0, data: err.error });
                    observer.complete();
                });
        });
    }

    uploadFile(url, file: File): Observable<any> {

        const formData = new FormData();
        formData.append('file', file);
    
        const headers = new HttpHeaders({ 'enctype': 'application/x-www-form-urlencoded; charset=UTF-8' });
    
        return this.httpClient.post(url, formData, { headers: headers });
    
      }

    postRequest = (url, data, options) => {
        return new Observable(observer => {
            this.httpClient.post(url, data, options)
                .subscribe(returnVal => {
                    observer.next({ apiCallStatus: 1, data: returnVal });
                    observer.complete();
                }, (err) => {                       
                        observer.next({ apiCallStatus: 0, data: err.error });
                        observer.complete();
                });
        });
    }

    putRequest(url, data, options):Observable<any>{
        return new Observable(observer => {
            this.httpClient.put(url, data, options)
                .subscribe(returnVal => {                    
                    observer.next({ apiCallStatus: 1, data: returnVal });
                    observer.complete();                    
                }, (err) => {                        
                        observer.next({ apiCallStatus: 0, data: err.error });
                        observer.complete();
                });
        });
    }
    deleteRequest = (url, options) => {
        return new Observable(observer => {
            this.httpClient.delete(url, options)
                .subscribe(returnVal => {
                    observer.next({ apiCallStatus: 1, data: returnVal });
                    observer.complete();
                }, (err) => {
                        console.log('There was an error getting data in base servce', err);
                        observer.next({ apiCallStatus: 0, data: err.error });
                        observer.complete();
                });
        });
    }

    getEntityData(entityName: string, params: any): Observable<any> {
        const url = ENTITY_API_URL[entityName] + this.makeQueryString(params);
        return this.getRequest(url, null);
    }

}
